import '@mdi/font/css/materialdesignicons.min.css';
import { createVuetify } from 'vuetify';
import {
  VApp,
  VAppBar,
  VAppBarNavIcon,
  VAvatar,
  VBadge,
  VBtn,
  VBtnGroup,
  VBtnToggle,
  VCard,
  VCardActions,
  VCardItem,
  VCardSubtitle,
  VCardText,
  VCardTitle,
  VCheckbox,
  VChip,
  VCol,
  VContainer,
  VDialog,
  VDivider,
  VExpandTransition,
  VExpansionPanel,
  VExpansionPanels,
  VExpansionPanelText,
  VExpansionPanelTitle,
  VIcon,
  VImg,
  VLayout,
  VList,
  VListGroup,
  VListItem,
  VListItemSubtitle,
  VListItemTitle,
  VListSubheader,
  VMain,
  VMenu,
  VNavigationDrawer,
  VProgressCircular,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VRow,
  VSelect,
  VSkeletonLoader,
  VSnackbar,
  VSpacer,
  VTab,
  VTable,
  VTabs,
  VTabsWindow,
  VTabsWindowItem,
  VTextarea,
  VTextField,
  VToolbarTitle,
  VVirtualScroll,
} from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/styles';

import { getBrowserLocale } from '@shared/helpers/browser';
import { VAutocomplete } from 'vuetify/components/VAutocomplete';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import { en, id, ja, vi } from 'vuetify/locale';

export const vuetify = createVuetify({
  components: {
    VBtn,
    VContainer,
    VApp,
    VAppBar,
    VIcon,
    VNavigationDrawer,
    VLayout,
    VAppBarNavIcon,
    VToolbarTitle,
    VSpacer,
    VMain,
    VDialog,
    VProgressCircular,
    VCard,
    VCardText,
    VCardTitle,
    VCardSubtitle,
    VCardActions,
    VCardItem,
    VList,
    VListItem,
    VListItemTitle,
    VListItemSubtitle,
    VListGroup,
    VListSubheader,
    VMenu,
    VImg,
    VDivider,
    VVirtualScroll,
    VTextField,
    VBtnGroup,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelText,
    VExpansionPanelTitle,
    VTabs,
    VTab,
    VTabsWindow,
    VTabsWindowItem,
    VChip,
    VAvatar,
    VRow,
    VCol,
    VSelect,
    VExpandTransition,
    VSkeletonLoader,
    VCheckbox,
    VRadioGroup,
    VRadio,
    VBadge,
    VTextarea,
    VProgressLinear,
    VSnackbar,
    VTable,
    VAutocomplete,
    VBtnToggle,
  },
  directives,
  locale: {
    locale: getBrowserLocale(),
    fallback: 'en',
    messages: { ja, en, vi, id },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    global: {},
    VTextField: {
      variant: 'solo-filled',
      rounded: 'xl',
      flat: true,
    },
    VTextarea: {
      variant: 'solo-filled',
      rounded: 'xl',
      flat: true,
    },
    VBtn: {
      variant: 'tonal',
      rounded: 'xl',
    },
  },
});
